<template>
  <!-- begin:: Footer -->
  <footer id="footer">
    <div class="container pt-4 d-flex justify-content-between">
      <div class="copyright">
        <!-- &copy; Copyright <strong><span>Socofar</span></strong>. All Rights Reserved -->
      </div>
      <div class="logo">
        <img class="" src="/media/img/femsa-gris.png" alt="" width="150">
        <p>©2020</p>
      </div>

      <div class="credits">
        <!-- Designed by <a href="https://bootstrapmade.com/">Soledad Moris</a> -->
      </div>
    </div>
  </footer>
  <!-- end:: Footer -->
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "KTFooter",
  computed: {
    ...mapGetters(["layoutConfig"]),

    /**
     * Check if footer container is fluid
     */
    widthFluid() {
      return this.layoutConfig("footer.width") === "fluid";
    }
  }
};
</script>
